export const DOCUMENTO_MAX_BYTES = 1 * 1024 * 1024

export const DOCUMENTO_EXTENSOES = ['pdf', 'jpg', 'jpeg', 'png']

export function extensaoPermitida(originalName) {
  if (!originalName || typeof originalName !== 'string') {
    return null
  }
  const base = originalName.split(/[/\\]/).pop() || ''
  const match = base.match(/\.([a-zA-Z0-9]+)$/)
  if (!match) {
    return null
  }
  const ext = match[1].toLowerCase()
  if (DOCUMENTO_EXTENSOES.indexOf(ext) < 0) {
    return null
  }
  return ext
}

export function validarArquivoDocumento(file) {
  if (!file) {
    return { ok: false, error: 'Selecione um arquivo' }
  }
  if (file.size > DOCUMENTO_MAX_BYTES) {
    return { ok: false, error: 'Arquivo deve ter no máximo 1 MB' }
  }
  const ext = extensaoPermitida(file.name)
  if (!ext) {
    return {
      ok: false,
      error: 'Formato inválido. Use PDF, JPG, JPEG ou PNG'
    }
  }
  return { ok: true, extensao: ext }
}

function tryParseJson(raw) {
  try {
    return JSON.parse(raw)
  } catch (_err) {
    return null
  }
}

export function parseDescricaoDocumento(raw) {
  const trimmed = (raw || '').trim()
  if (!trimmed) {
    return { kind: 'empty' }
  }
  const parsed = tryParseJson(trimmed)
  if (!parsed || typeof parsed !== 'object') {
    return { kind: 'empty' }
  }
  const storage_key =
    typeof parsed.storage_key === 'string' ? parsed.storage_key.trim() : ''
  const nome_arquivo =
    typeof parsed.nome_arquivo === 'string' ? parsed.nome_arquivo.trim() : ''
  const enviado_em =
    typeof parsed.enviado_em === 'string' ? parsed.enviado_em.trim() : ''
  if (!storage_key || !nome_arquivo) {
    return { kind: 'empty' }
  }
  if (enviado_em) {
    return {
      kind: 'definitivo',
      storage_key,
      nome_arquivo,
      enviado_em
    }
  }
  return {
    kind: 'pending',
    storage_key,
    nome_arquivo
  }
}

export function documentoTemArquivo(descricao) {
  const parsed = parseDescricaoDocumento(descricao)
  return parsed.kind === 'pending' || parsed.kind === 'definitivo'
}

export function serializePending({ storage_key, nome_arquivo }) {
  return JSON.stringify({
    storage_key,
    nome_arquivo
  })
}
